import React from 'react';
import { CustomDialog } from '../../../components/StyledComponents';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import {
   ControlpanelPrimaryButton,
   ControlpanelSecondaryButton,
   GrayIconButton
} from '../../../components/StyledButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import { deleteGroupAdmin } from '../../../axios/Group/GroupUrlApi';
import { toast } from 'react-toastify';

const RemoveUserFromGroupDialog = (props) => {
   const { t } = useTranslation();
   const {
      open,
      onClose,
      selectedUserRemove,
      groupId,
      groupName,
      groupCode,
      handleRefreshInfo
   } = props;

   const handleConfirmRemove = async () => {
      try {
         const res = await deleteGroupAdmin({
            userId: selectedUserRemove.userId,
            group: groupId,
            langId: localStorage.getItem('i18nextLngId')
         });

         if (res.status === 204 || res.status === 200) {
            toast.success(t('common.remove-user-success'));
            handleRefreshInfo?.(); 
            onClose();
         }
      } catch (error) {
         toast.error(t('common.remove-user-failed'));
      }
   };

   return (
      <CustomDialog
         transitionDuration={300}
         maxWidth="sm"
         open={open}
         onClose={onClose}
         keepMounted
      >
         <DialogTitle>
            <div className="flex justify-between">
               <div className="flex items-center gap-4">
                  <div className="w-1 h-8 bg-[#FEF08A]" />
                  <p className="text-xl font-semibold">
                     {t('button.remove-user')}
                  </p>
               </div>
               <GrayIconButton onClick={onClose}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>

         <DialogContent>
            <p className="pt-4">
               {t('common.remove-user-from-group', {
                  user: selectedUserRemove?.fullName,
                  group: groupName
               })}
            </p>
         </DialogContent>

         <DialogActions>
            <div className="flex gap-2 px-4 py-4">
               <ControlpanelSecondaryButton onClick={onClose}>
                  <CloseIcon />
                  {t('button.cancel')}
               </ControlpanelSecondaryButton>

               <ControlpanelPrimaryButton onClick={handleConfirmRemove}>
                  <CheckIcon />
                  {t('button.ok')}
               </ControlpanelPrimaryButton>
            </div>
         </DialogActions>
      </CustomDialog>
   );
};

export default RemoveUserFromGroupDialog;
